import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="py-16 bg-stone-950 border-t border-stone-800" data-id="element-1389">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1390">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-1391">
          {/* Brand */}
          <div className="md:col-span-4" data-id="element-1392">
            <p className="font-serif text-xl text-stone-50 mb-4" data-id="element-1393">BlockQuote</p>
            <p className="text-stone-400 max-w-sm leading-relaxed" data-id="element-1394">
              Instant group quotes. One-click holds. Direct resort pricing. The
              infrastructure layer for group travel.
            </p>
          </div>

          {/* Platform */}
          <div className="md:col-span-2" data-id="element-1395">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1396">
              Platform
            </p>
            <ul className="space-y-3" data-id="element-1397">
              <li data-id="element-1398">
                <button onClick={() => scrollTo('features')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1399">
                  Product
                </button>
              </li>
              <li data-id="element-1400">
                <button onClick={() => scrollTo('pricing')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1401">
                  Pricing
                </button>
              </li>
              <li data-id="element-1402">
                <button onClick={() => scrollTo('proof')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1403">
                  Case Study
                </button>
              </li>
            </ul>
          </div>

          {/* Demos */}
          <div className="md:col-span-3" data-id="element-1404">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1405">
              Live Demos
            </p>
            <ul className="space-y-3" data-id="element-1406">
              <li data-id="element-1407">
                <Link to="/app" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1408">
                  Resort Dashboard
                </Link>
              </li>
              <li data-id="element-1409">
                <Link to="/agency" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1410">
                  Agency Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3" data-id="element-1411">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1412">
              Company
            </p>
            <ul className="space-y-3" data-id="element-1413">
              <li data-id="element-1414">
                <Link to="/deck" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1415">
                  Pitch Deck
                </Link>
              </li>
              <li data-id="element-1416">
                <Link to="/pilot_for_Lomas" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1417">
                  Pilot for Lomas
                  <span className="font-mono text-[10px] text-red-600 border border-red-600/30 px-1.5 py-0.5" data-id="element-1418">
                    PILOT
                  </span>
                </Link>
              </li>
              <li data-id="element-1419">
                <Link to="/execution" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1420">
                  Resort Execution Deck
                  <span className="font-mono text-[10px] text-amber-400 border border-amber-400/30 px-1.5 py-0.5" data-id="element-1421">
                    LOMAS
                  </span>
                </Link>
              </li>
              <li data-id="element-1422">
                <Link to="/onboarding/lomas" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1423">
                  Lomas Onboarding
                  <span className="font-mono text-[10px] text-emerald-500 border border-emerald-500/30 px-1.5 py-0.5" data-id="element-1424">
                    PILOT
                  </span>
                </Link>
              </li>
              <li data-id="element-1425">
                <Link to="/dev-plan" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1426">
                  Dev Plan
                  <span className="font-mono text-[10px] text-cyan-400 border border-cyan-400/30 px-1.5 py-0.5" data-id="element-1427">
                    PRD
                  </span>
                </Link>
              </li>
              <li data-id="element-1428">
                <Link to="/salesforce" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1429">
                  Salesforce Integration
                  <span className="font-mono text-[10px] text-blue-400 border border-blue-400/30 px-1.5 py-0.5" data-id="element-1430">
                    SAFE
                  </span>
                </Link>
              </li>
              <li data-id="element-1431">
                <Link to="/quote-speed-os" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1432">
                  Quote Speed OS
                  <span className="font-mono text-[10px] text-red-500 border border-red-500/30 px-1.5 py-0.5" data-id="element-1433">
                    HUB
                  </span>
                </Link>
              </li>
              <li data-id="element-1434">
                <button onClick={() => scrollTo('cta')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1435">
                  Request Pilot
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-1436">
          <p className="font-mono text-xs text-stone-500" data-id="element-1437">
            © 2026 BlockQuote. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-1438">
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-1439">
              Privacy
            </span>
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-1440">
              Terms
            </span>
          </div>
        </div>
      </div>
    </footer>;
}